import React, { useContext, useRef, useState } from "react";

import PROFILE from "../../assets/profilePic.svg";
import ProfileMenu from "../ProfileMenu/ProfileMenu";

import { RxHamburgerMenu } from "react-icons/rx";
import { useNavigate } from "react-router-dom";
import { HiPlus } from "react-icons/hi";
import HandleClickOutside from "../../utils/helpers/HandleOutsideClick";
import { AppContext } from "../../utils/Context/AppContext";
import { useLocation } from "react-router-dom";
import { newSession } from "../../utils/services/api";
import NecaLogo from "../../assets/NecaLogo.png";

const NavBar = ({ setShowMobileSideBar, showMobileSidebar }) => {
  const navigate = useNavigate();

  const ref = useRef();
  const idToken = localStorage.getItem("idToken");
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const location = useLocation();
  const isMainRoute = location.pathname === "/main";
  const { dispatch, setMessages, isAdmin } = useContext(AppContext);
  const loginRoute = location.pathname === "/";
  const pathname = location.pathname;
  const uploadRoute = location.pathname === "/upload-audio";
  const isChatRoute = pathname.startsWith("/chat");
  const isMobile = window.innerWidth < 768; // Basic JS check

  HandleClickOutside(ref, () => setShowProfileMenu(false));

  const handleCreateNewChat = async () => {
    try {
      const newSessionId = await newSession();
      dispatch({
        type: "NEW_SESSION_ID",
        payload: newSessionId,
      });
      navigate(`${window.location.pathname}?new_conversation`);
      setMessages([]);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <nav className="navbar bg-[#fff] flex items-center justify-between py-[5px] px-[22px] h-[50px]">
      {/* <div className="sm:hidden flex items-center gap-4">
        {!isMainRoute && !loginRoute && !uploadRoute && (
          <RxHamburgerMenu
            className="h-6 w-6 cursor-pointer"
            onClick={() => setShowMobileSideBar(!showMobileSidebar)}
          />
        )}
        <Link to="/main">
          <img
            // ref={hamburgerRef}
            className="h-[30px] w-auto cursor-pointer"
            src={LOGO}
            alt="Logo"
          />
        </Link>
      </div> */}
      <div className="sm:hidden flex items-center gap-4">
        {!isMainRoute && !loginRoute && !uploadRoute && (
          <RxHamburgerMenu
            className="h-6 w-6 cursor-pointer"
            onClick={() => setShowMobileSideBar(!showMobileSidebar)}
          />
        )}
        <button
          onClick={() => {
            if (isAdmin) {
              navigate("/main");
            }
          }}
        >
          {/* <img
            className="h-[35px] w-[130px] cursor-pointer"
            src={logoNecaNew}
            alt="logo"
          /> */}
          <img
            className="h-[35px] w-[50px] cursor-pointer"
            src={NecaLogo}
            alt="logo"
          />
        </button>
      </div>
      {/* <div className="hidden sm:inline-block sm:h-full h-[50px] max-w-[121px] w-fit">
        <Link to="/main">
          <img
            className="h-[40px] w-[130px] cursor-pointer"
            src={LOGO}
            alt="logo"
          />
        </Link>
      </div> */}
      <div className="hidden sm:flex sm:items-center sm:justify-center sm:h-full h-[50px] w-auto">
        <button
          onClick={() => {
            if (isAdmin) {
              navigate("/main");
            }
          }}
          className="flex items-center justify-center "
        >
          {/* <img
            className="h-[35px] w-[130px] cursor-pointer"
            src={logoNecaNew}
            alt="logo"
          /> */}
          <img
            className="h-[35px] w-[50px] cursor-pointer"
            src={NecaLogo}
            alt="logo"
          />
        </button>
      </div>

      <div className="flex items-center gap-5">
        {/* ✅ Show New Chat: only on mobile and on /chat */}
       {isMobile && isChatRoute && (
          <div className="block md:hidden">
            <button
              onClick={handleCreateNewChat}
              className="text-sm flex items-center gap-2 text-[#242424]"
            >
              New Chat
              <span>
                <HiPlus color="#242424" size={16} />
              </span>
            </button>
          </div>
        )}

        {/* Show Profile: 
        - Always on desktop
        - On mobile ONLY for /main
  */}
        {idToken && ((isMainRoute && isMobile) || !isMobile) && (
          <div className="block h-full" ref={ref}>
            <img
              className="h-[35px] cursor-pointer"
              src={PROFILE}
              alt="profile"
              onClick={() => setShowProfileMenu(!showProfileMenu)}
            />
            {showProfileMenu && (
              <ProfileMenu setShowProfileMenu={setShowProfileMenu} />
            )}
          </div>
        )}
      </div>
    </nav>
  );
};

export default NavBar;
